import React, { createContext, useContext, useState, useTransition } from "react";
import { isMobile } from "react-device-detect";

const UxVersionContext = createContext({ isUpgraded: false, toggleVersion: () => {} });

export const UxVersionProvider = ({ children }) => {
  const [isUpgraded, setIsUpgraded] = useState(
    sessionStorage.getItem("uxVersion") !== "v1"
  );
  const [, startTransition] = useTransition();

  const toggleVersion = () => {
    if (isMobile) return;
    const next = !isUpgraded;
    if (next) sessionStorage.setItem("uxVersion", "v2");
    else sessionStorage.setItem("uxVersion", "v1");
    // Wrap state update in startTransition to handle lazy component suspense
    startTransition(() => {
      setIsUpgraded(next);
    });
  };

  return (
    <UxVersionContext.Provider value={{ isUpgraded, toggleVersion }}>
      {children}
    </UxVersionContext.Provider>
  );
};

export const useUxVersion = () => useContext(UxVersionContext);
